<template>
  <div>
    <indexHeader ref="indexHeader"></indexHeader>
    <div class="index_new load_inLeft">
      <div class>
        <h3>法人信息认证</h3>
        <el-form ref="form" :model="form" :rules="rules">
          <el-row :gutter="20">
            <el-col :span="20">
             <!-- <el-form-item label="请选择您需要的培训服务" prop="qyFwnr">
                <div style="position: relative;display: inline-block;width: 100%;">
                  <el-checkbox-group v-model="form.qyFwnr" @change="checkboxChange">
                    <div class="form_span">
                      <el-checkbox :disabled="isEdit==1" label="0">培训</el-checkbox>
                      <span>（材料清单：处罚通知书、履约证明、营业执照、法定代表人身份证、信用承诺书）</span>
                    </div>
                    <div class="form_span" v-if="lxCjbg == 1">
                      <el-checkbox :disabled="isEdit==1" label="1">报告</el-checkbox>
                      <span>（材料清单：处罚通知书、履约证明、营业执照、法定代表人身份证、信用承诺书、培训证明）</span>
                    </div>
                  </el-checkbox-group>
                </div>
              </el-form-item> -->
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="1.上传企业资料">
                <div class="file_ul">
                  <div class="file_li" v-for="(item,key,index) in fileType" :zx="key">
                    <div
                      class="file_img"
                      @click="drawer = true , activeType = key, activeTypeCode = 0"
                    >
                      <img
                        v-if="form.file[key][0]"
                        :src="getfjimg(form.file[key][0],'',key)"
                        style="margin-top: -30px;width: 237px;height: 144px"
                      />
                      <div v-else>
						 <img v-if="index == 0" src="/static/images/new/yyzz.png" alt="">
						 <img v-if="index == 1" src="/static/images/new/sfz.png" alt="">
                        <!-- <em class="iconfont">&#xe740;</em> -->
                        <!-- <p>点击上传</p> -->
                      </div>
                    </div>
                    <!--只有 只选择报告服务的时候需要培训证明-->
                    <!-- <p v-if="key == 6" zx="123" :class="{ 'must' : form.qyFwnr.indexOf('1') >= 0 && form.qyFwnr.length == 1}">{{item}}</p>
										<p v-else-if="key == 8" zx="456">{{item}}</p>
                    <p v-else :class="{ 'must' : (form.qyFwnr.indexOf('1') >= 0 && key > 4) ||  key <= 4 }">{{item}}</p>-->
                    <p zx="456">{{item}}</p>
                    <div v-if="form.file[key][0]" class="ysc">
                      <span class="iconfont">&#xe744;</span> 已上传
                    </div>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="企业名称" prop="qyMc">
                <el-input v-model="form.qyMc" placeholder="请填写"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="统一社会信用代码" prop="qyXydm">
                <el-input v-model="form.qyXydm" placeholder="请填写"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="法定代表人姓名" prop="qyFdxm">
                <el-input v-model="form.qyFdxm" placeholder="请填写"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="法定代表人身份证" prop="qyFdsfz">
                <el-input v-model="form.qyFdsfz" placeholder="请填写"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row>
          <el-col :span="12">
            <el-form-item label="6.法定代表人手机号" prop="qyTel">
              <el-input v-model="form.qyTel" placeholder="请填写" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          </el-row>-->


          <el-row v-if="qyActive == 0">
            <el-col :span="24">
              <el-form-item label="2.上传处罚资料">
                <el-button @click="addCfzl" type="primary" style="float:right;" size="small">＋新增处罚资料</el-button>
                <div class="file_ul">
                  <div v-for="(item_1,index_1) in fileTypeOne" style="clear: both;">
                    <div
                      style="dispaly: inline-block; float: left;margin-bottom:33px;"
                      class="file_li"
                      v-for="(item,key,index) in item_1"
                      :zx="key"
                    >
                      <div
                        class="file_img"
                        @click="drawer = true , activeType = key, activeTypeCode = index_1"
                      >
                        <img
                          v-if="sccfBooleanBoolean(form.file[key], index_1, key)"
                          :src="sccfBooleanUrl(form.file[key], index_1,key)"
                          style="width: 237px;height: 144px"
                        />
                        <div v-else>
							<img v-if="index == 0" src="/static/images/new/cf.png" alt="">
							<img v-else-if="index == 1"src="/static/images/new/ly.png" alt="">
							<img v-else-if="index == 2" src="/static/images/new/cns.png" alt="">
                          <!-- <em class="iconfont">&#xe740;</em> -->
                          <!-- <p>点击上传</p> -->
                        </div>
                      </div>
                      <!--只有 只选择报告服务的时候需要培训证明-->
                      <p
                        v-if="key == 6"
                        zx="123"
                        :class="{ 'must' : form.qyFwnr.indexOf('1') >= 0 && form.qyFwnr.length == 1 }"
                      >{{item}}</p>
                      <!-- <p v-else :class="{ 'must' : key <= 5  && key != 1}">{{item}}</p> -->
                      <!-- 去除处罚资料必填项 -->
                      <p v-else>{{item}}</p>
                      <!-- <div v-if="sccfBooleanBoolean(form.file[key], index_1, key)" class="ysc">
                        <span class="iconfont">&#xe744;</span>
                        已上传
                      </div> -->
                    </div>
                    <div style="dispaly: inline-block; float: left;margin-top:-20px;">
                      <div>
                        <!-- <el-col style="clear:both;">
                          <el-form-item label="处罚文号" style="float:Left;">
                            <el-input
                              style="width:400px;"
                              v-model="form.qyCfwh[index_1]"
                              @blur="requireBtcf(form.qyCfwh[index_1])"
                              placeholder="处罚文号"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col style="clear:both;">
                          <el-form-item label="处罚时间" style="float:Left;">
                            <el-date-picker
                              value-format="yyyy-MM-dd"
                              placeholder="处罚时间"
                              v-model="form.qyCfsj[index_1]"
                              @blur="requireBtcf_1(form.qyCfsj[index_1], index_1)"
                              style="width: 400px;"
                            ></el-date-picker>
                          </el-form-item>
                        </el-col> -->
                      </div>
                    </div>
                    <div
                      v-if="index_1 != 0"
                      class="iconfont icon-del"
                      @click="delCfzl(index_1)"
                    >&#xe745;</div>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div v-if="form.qyFwnr.length > 0" class="submit" @click="tprzClickSub()">提交</div>
        <div v-else class="submit an">提交</div>
      </div>
      <el-dialog title="资料上传" width="30%" :lock-scroll="false" :visible.sync="drawer">
        <p class="drawer_p">只能上传jpg/png文件，且不超过2MB！</p>
        <div class="input_ul clearfix">
          <div
            v-if="item.url"
            class="input_li load_inLeft"
            v-for="(item,index) in sccfBooleanUrlArray(form.file[activeType],activeType,activeTypeCode)"
            @mouseenter="activeDeawerFileIndex = index"
          >
            <img :src="item.url" />
            <div
              class="mask iconfont"
              v-if="activeDeawerFileIndex == index"
              @mouseleave="activeDeawerFileIndex = -1"
              @click="delFlie(index,item)"
            >&#xe745;</div>
          </div>
          <div class="uploadBnt">
            <input type="file" @change="fileChange" id="drawerFileInput" />
            <div class="bg iconfont" @click="bgClick">&#xe740;</div>
          </div>
        </div>
        <!-- <el-button type="primary" size="mini" style="margin: 20px 0 0 15px" @click="peroFj()">上一项</el-button> -->
        <!-- <el-button type="primary" size="mini" style="margin: 20px 0 0 15px" @click="nextFj()">下一项</el-button> -->
      </el-dialog>
    </div>
    <indexFooter></indexFooter>
  </div>
</template>

<script>
import { cookie } from "@/common/js/cookies.js";
import indexHeader from "@/components/index/index_header";
import indexFooter from "@/components/index/index_footer";
export default {
  name: "index_new",
  data() {
    var checkphone = (rule, value, callback) => {
      // let phoneReg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;
      if (value == "") {
        callback(new Error("请输入手机号"));
      } else if (!this.isCellPhone(value)) {
        //引入methods中封装的检查手机格式的方法
        callback(new Error("请输入正确的手机号！"));
      } else {
        callback();
      }
    };

    return {
      subDel: false, //确认是否点击了已核对内容
      drawer: false,
      lxId:null,//类型id
      cfsxList: null, //修改页面时处罚资料
      lxCjbg: null, //是否显示报告
      qyActive: null, //判断是否非浙江企业
	  currentTime:null,  //当前时间
      form: {
        qyFdxm: null, //法定代表人姓名
        qyFdsfz: null, //法定代表人身份证
        qyMc: null, //企业名称
        qyXydm: null, //社会信用代码
        qyFwnr: ["0", "1"], //判断上传资料中*的显示
        // qyTel: null,		//法定代表人手机号
        file: {
          //所有上传7类资料的数据集合
          1: [[]],
          2: [[]],
          3: [],
          4: [],
          5: [{}],
          6: [],
          8: [],
        },
        qyCfwh: [""],
        qyCfsj: [""],
      },
      activeDeawerFileIndex: -1,
      rules: {
        qyFdxm: [
          { required: true, message: "请输入", trigger: "change" },
          { min: 1, max: 10, message: "10个字以内", trigger: "change" },
        ],
        qyFdsfz: [
          { required: true, message: "请输入", trigger: "change" },
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "你的身份证格式不正确",
          },
        ],
        qyMc: [
          { required: true, message: "请输入", trigger: "change" },
          {
            min: 4,
            max: 20,
            message: "企业名称在4-20位之间",
            trigger: "change",
          },
        ],
        qyXydm: [{ required: true, message: "请输入", trigger: "change" }],
        // qyTel: [{ required: true, trigger: "change", validator: checkphone }]
      },
      activeType: 1, //key值
      activeTypeCode: 0, //file的下标index
      fileType: {
        // 1: '处罚通知书',
        // 2: '履约证明',
        3: "营业执照",
        4: "法定代表人身份证",
        // 5: '信用承诺书',
        // 6: "培训证明",
        // 8: "公益服务材料",
      },
      fileTypeOne: [
        {
          1: "处罚通知书",
          2: "履约证明",
          5: "信用承诺书",
        },
      ],
      isEdit: 0,
      isApplyFor: 1,
    };
  },
  created() {
    //区分是申请报告还是外省关联企业 0申请报告 1关联企业
    let isApplyFor = this.$route.query.isApplyFor;
    this.lxId= this.$route.query.pxlx;
    this.isApplyFor = isApplyFor ? 0 : 1;
  },
  mounted() {
    this.lxCjbg = this.$route.query.lxCjbg;
    this.qyActive = this.$route.query.qyActive;
    document.getElementsByClassName("header")[0].style.background = "#fff";
    this.isEdit = this.$route.query.edit;
    if (this.isEdit == 1) {
      this.qyrzDetails();
    }
	// 获取当前时间
	this.currentTime = this.getNowFormatDate();
  },
  components: {
    indexHeader,
    indexFooter,
  },
  methods: {
    getfjimg(item, cfzlIdex, index) {
      // this.getFjwz(item,cfzlIdex,index)
      return item.url;
    },
    getFjwz(item, cfzlIdex, index) {
      // console.log(index);
      // console.log(cfzlIdex);
      // console.log(item);
      let itemFile;
      if (index == 5) {
        itemFile = item[cfzlIdex].objfile;
      } else {
        itemFile = item.objfile;
      }
      if (!itemFile) {
        return;
      }
      let _self = this;
      let ajax = _self.$http.create({
        headers: {
          "Content-Type": "multipart/form-data",
          token: cookie.get("xyxf_token_qt"),
        },
      });
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let formData = new FormData();
      formData.append("fjType", index);
      formData.append("file", itemFile);
      ajax({
        method: "post",
        url: SOWINURL + "wzsb/getFjwz",
        data: formData,
      })
        .then(function (json) {
          if (json.data.result == 1) {
            if (index == 4) {
              _self.form["qyFdxm"] = json.data.data.name;
              _self.form["qyFdsfz"] = json.data.data.IDCard;
            } else if (index == 5) {
              let cfsj = json.data.data.cfsj;
              //正则去掉中文字符
              let reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
              if (reg.test(cfsj)) {
                cfsj = null;
              }
              _self.form["qyCfsj"][cfzlIdex] = cfsj;
              _self.form["qyCfwh"][cfzlIdex] = json.data.data.cfwh;
            } else if (index == 3) {
              _self.form["qyXydm"] = json.data.data.yxdm;
              _self.form["qyMc"] = json.data.data.dwmc;
            }
            // console.log(_self.form);
          } else {
            _self.$message({
              showClose: true,
              message: json.data.errorcode,
              type: "error",
            });
          }
          loading.close();
        })
        .catch(function (error) {
          loading.close();
          console.log(error);
        });
    },
    delCfzl(index) {
      console.log(index);
      let _self = this;
      _self.form.file["1"].splice(index, 1);
      _self.form.file["2"].splice(index, 1);
      _self.form.file["5"].splice(index, 1);
      _self.form["qyCfwh"].splice(index, 1);
      _self.form["qyCfsj"].splice(index, 1);
      _self.fileTypeOne.splice(index, 1);

      //执行这个才不会报错
      _self.activeType = 2;
      _self.activeTypeCode = index - 1;

      //如果是携带修改参数时
      if (_self.isEdit == 1) {
        if (index < _self.cfsxList.length) {
          _self.clearCfzl(index);
        } else {
          console.log(index, _self.cfsxList.length);
        }
      }
    },
    //删除整行接口
    clearCfzl(index) {
      let _self = this;
      let ajax = _self.$http.create();
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      ajax({
        method: "post",
        url: SOWINURL + "index/delQycfsx",
        data: {
          qy2cfsxId: _self.cfsxList[index].qy2cfsxId,
        },
        headers: {
          token: cookie.get("xyxf_token_qt"),
        },
      })
        .then(function (json) {
          if (json.data.result == 1) {
            _self.$message("已删除");
          } else {
            _self.$message({
              showClose: true,
              message: json.data.errorcode,
              type: "error",
            });
          }
          loading.close();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    requireBtcf(data) {
      if (typeof data == "string" && data.length > 0) {
      } else {
      }
    },
    requireBtcf_1(data, index) {
      let _self = this;
      if (typeof data == "string" && data.length == 0) {
        // console.log("未选择时间");
      }
      if (typeof data == "object") {
        data = data ? data.format("yyyy-MM-dd hh:mm:ss") : "";
        _self.form.qyCfsj[index] = data;
        if (data.length > 0) {
          console.log(data);
        } else {
        }
      } else {
      }
    },
    addCfzl() {
      let _self = this;
      let data = "";
      _self.form.qyCfwh.push(data);
      _self.form.qyCfsj.push(data);
      _self.fileTypeOne.push({
        1: "处罚通知书",
        2: "履约证明",
        5: "信用承诺书",
      });
      //每次新增处罚资料时对上传处罚资料增加一个对象
      let fileIndex = _self.fileTypeOne.length - 1;
      _self.form.file["1"][fileIndex] = [];
      _self.form.file["2"][fileIndex] = [];
      _self.form.file["5"][fileIndex] = {};
      // console.log(fileIndex,_self.form.file['1'])
    },
    sccfBooleanBoolean(urlData, index, ke) {
      let url = "";
      let boolean = false;

      for (let key in urlData) {
        if (ke == 1 || ke == 2) {
          if (urlData[index][0]) {
            boolean = true;
          }
        } else {
          // console.log(key,index,urlData[index])
          if (urlData[index].url) {
            boolean = true;
          }
        }
        return boolean;
      }

      return boolean;
    },
    sccfBooleanUrl(urlData, index, iIndex) {
      let url = "";
      for (let key in urlData) {
        if (iIndex == 1) {
          if (urlData[index][0]) {
            url = this.form.file["1"][index][0].url;
            // boolean = true;
          }
        } else if (iIndex == 2) {
          if (urlData[index][0]) {
            url = this.form.file["2"][index][0].url;
            // boolean = true;
          }
        } else {
          if (urlData[index].url) {
            url = urlData[index].url;
          }
        }
        return url;
      }

      return "";
    },
    sccfBooleanUrlArray(urlArray, ke, code) {
      let _self = this;
      let urlData = [];
      let isEdit = this.isEdit;
      let i;
      if (ke == 1 || ke == 2 || ke == 5) {
        // i =  JSON.parse(JSON.stringify(urlArray))[code];
        if (ke == 1 || ke == 2) {
          urlData = urlArray[code];
        } else {
          urlData.push(urlArray[code]);
        }
      } else {
        urlData = urlArray;
      }
      return urlData;
    },
    //修改请求时触发
    qyrzDetails() {
      let _self = this;
      let ajax = _self.$http.create();
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      ajax({
        method: "GET",
        url: SOWINURL + "index/qyrzDetails",
        params: {
          qyId: _self.$route.query.qyId,
        },
        headers: {
          token: cookie.get("xyxf_token_qt"),
        },
      })
        .then(function (json) {
          if (json.data.result == 1) {
            // console.log(json.data.data)
            _self.form.qyFdxm = json.data.data.qy.qyFdxm;
            _self.form.qyFdsfz = json.data.data.qy.qyFdsfz;
            _self.form.qyMc = json.data.data.qy.qyMc;
            _self.form.qyXydm = json.data.data.qy.qyXydm;
            _self.cfsxList = json.data.data.cfsxList;
            // _self.form.qyTel = json.data.data.qy.qyTel;
            if (json.data.data.qy.qyFwnr == 0) {
              _self.form.qyFwnr = ["0"];
            }
            // console.log(_self.form.qyFwnr)
            if (json.data.data.qy.qyFwnr == 1) {
              _self.form.qyFwnr = ["1"];
            }
            if (json.data.data.qy.qyFwnr == 2) {
              _self.form.qyFwnr = ["0", "1"];
            }
            //循环处罚资料
            // console.log(json.data.data.cfsxList)
            _self.fileTypeOne = [];

            for (let i in json.data.data.cfsxList) {
              // console.log(i,json.data.data.cfsxList)
              _self.form.qyCfwh[i] = json.data.data.cfsxList[i].cfwh;
              _self.form.qyCfsj[i] = json.data.data.cfsxList[i].cfsj;
              _self.fileTypeOne.push({
                1: "处罚通知书",
                2: "履约证明",
                5: "信用承诺书",
              });
            }

            //循环处罚资料份数

            let cffsLeng = json.data.data.cfsxList.length; //总份数
            let cftzsArr = []; //处罚通知书的总数据
            let lyzmArr = []; //履约证明的总数据
            let xycnsArr = []; //信用承诺书的总数据
            for (let i in json.data.data.fjList) {
              if (json.data.data.fjList[i].fjType == "1") {
                cftzsArr.push(json.data.data.fjList[i]);
              } else if (json.data.data.fjList[i].fjType == "2") {
                lyzmArr.push(json.data.data.fjList[i]);
              } else if (json.data.data.fjList[i].fjType == "5") {
                xycnsArr.push(json.data.data.fjList[i]);
              } else {
                _self.form.file[json.data.data.fjList[i].fjType].push(
                  json.data.data.fjList[i]
                );
              }
            }

            _self.form.file["1"].splice(0, 1); //先清理一下一开始多余的自定义的空数据
            _self.form.file["2"].splice(0, 1);
            _self.form.file["5"].splice(0, 1);
            for (let b = 0; b < cffsLeng; b++) {
              //再给每一份的框里加一个空数据
              _self.form.file["2"][b] = [];
              _self.form.file["5"][b] = {};
              _self.form.file["1"][b] = [];
            }
            //将存储的index下标放入对应的框里
            for (let a in lyzmArr) {
              _self.form.file["2"][lyzmArr[a].index].push(lyzmArr[a]);
            }

            for (let b in xycnsArr) {
              _self.form.file["5"][xycnsArr[b].index] = xycnsArr[b];
            }

            for (let c in cftzsArr) {
              _self.form.file["1"][cftzsArr[c].index].push(cftzsArr[c]);
            }
          } else {
            _self.$message({
              showClose: true,
              message: json.data.errorcode,
              type: "error",
            });
          }
          loading.close();
        })
        .catch(function (error) {
          loading.close();
          console.log(error);
        });
    },
    // peroFj(){
    //   if(this.activeType > 1){
    //     this.activeType--;
    //   }else{
    //     this.activeType = 6;
    //   }
    // },
    // nextFj(){
    //   if(this.activeType < 6){
    //     this.activeType++;
    //   }else{
    //     this.activeType = 1;
    //   }

    // },
    checkboxChange() {
      // console.log('checkboxChange');
    },
	getNowFormatDate() {
		var date = new Date();
		var seperator1 = "-";
		var year = date.getFullYear();
		var month = date.getMonth() + 1;
		var strDate = date.getDate();
		if (month >= 1 && month <= 9) {
			month = "0" + month;
		}
		if (strDate >= 0 && strDate <= 9) {
			strDate = "0" + strDate;
		}
		var currentdate = year + seperator1 + month + seperator1 + strDate;
		return currentdate;
	},
    tprzClickSub() {
      //支付先确认一下提交信息正确再进行验证提交
      let _self = this;
      _self
        .$confirm("已仔细核对图片与上传材料内容无误,是否确认?", "友情提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          lockScroll: false,
          type: "warning",
        })
        .then(() => {
          _self.tprzClick();
        })
        .catch(() => {});
    },
    tprzClick() {

      //提交表单
      let _self = this;

      this.$refs["form"].validate((valid) => {
        if (valid) {
          //判断   "营业执照","法定代表人身份证","培训证明"
          if (this.qyActive == 1) {
            for (let key in _self.fileType) {
              if (
                _self.form.qyFwnr.indexOf("1") >= 0 &&
                _self.form.qyFwnr.length == 1
              ) {
                //只勾选报告服务的时候培训证明需要
                // if (_self.form.file[key] == 0 && key != '8') {
                //   _self.$message({
                //     showClose: true,
                //     message: "请上传" + _self.fileType[key],
                //     type: "error"
                //   });
                //   return false;
                // }
              } else {
                if (_self.form.file[key] == 0 && key != "6" && key != "8") {
                  _self.$message({
                    showClose: true,
                    message: "请上传" + _self.fileType[key],
                    type: "error",
                  });
                  return false;
                }
              }
            }
          }

          //判断  "处罚通知书","履约证明","信用承诺书"
          // for (let i in _self.fileTypeOne) {
          //   let key = _self.fileTypeOne[i];
          //   for (let key_1 in key) {
          //     let boolean = _self.sccfBooleanBoolean(_self.form.file[key_1], i,key_1);
          //     if (
          //       _self.form.qyFwnr.indexOf("1") >= 0 &&
          //       _self.form.qyFwnr.length == 1
          //     ) {
          //       //只勾选报告服务的时候培训证明不需要
          //       if (!boolean && key_1 != 6 && key_1 != 1) {
          //         _self.$message({
          //           showClose: true,
          //           message: "请上传" + key[key_1],
          //           type: "error"
          //         });
          //         return false;
          //       }
          //     } else {
          //       if (!boolean && key_1 != 1) {
          //         _self.$message({
          //           showClose: true,
          //           message: "请上传" + key[key_1],
          //           type: "error"
          //         });
          //         return false;
          //       }
          //     }
          //   }
          //   for (let i in _self.form.qyCfwh) {
          //     let time = _self.form.qyCfsj[i];
          //     if (_self.form.qyCfwh[i].length == 0) {
          //       _self.$message({
          //         showClose: true,
          //         message: "请输入处罚文号",
          //         type: "error"
          //       });
          //       return false;
          //     } else if (typeof time == "string" && time.length == 0) {
          //       _self.$message({
          //         showClose: true,
          //         message: "请选择处罚时间",
          //         type: "error"
          //       });
          //       return false;
          //     }
          //   }
          // }

          let qyFwnr = -1;
          if (_self.form.qyFwnr.length > 1) {
            qyFwnr = 2;
          } else {
            qyFwnr = _self.form.qyFwnr[0];
          }
          if (this.lxCjbg == 0) {
            qyFwnr = 0;
          }
          //重计算file中index下标后赋值
          for (let da in _self.form.file) {
            if (da == 1 || da == 2) {
              for (let da1 in _self.form.file[da]) {
                for (let dat in _self.form.file[da][da1]) {
                  _self.form.file[da][da1][dat].index = da1;
                }
              }
            } else if (da == 5) {
              for (let da2 in _self.form.file[da]) {
                _self.form.file[da][da2].index = da2;
              }
            }
          }

          if (_self.isEdit != 1) {
            let ajax = _self.$http.create({
              headers: {
                "Content-Type": "multipart/form-data",
                token: cookie.get("xyxf_token_qt"),
              },
            });

            const loading = this.$loading({
              lock: true,
              text: "Loading",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            });
            let formData = new FormData();
            if (this.qyActive == 1) {
              formData.append("wsqy", 1);
            }
            if (this.$route.query.qyId) {
              formData.append("qyId", this.$route.query.qyId);
            }
            if (this.$route.query.pxlx) {
              formData.append("pxlx", this.$route.query.pxlx);
            }

            for (let i in this.form) {
			  console.log(this.form[i])
              if (i == "qyFwnr") {
                formData.append("qyFwnr", 2);
              } else if (i == "qyCfwh") {
				this.form[i].qyCfwh = 'cfwh';
				console.log(this.form[i])
                formData.append("cfwh", this.form[i]);
              } else if (i == "qyCfsj") {
				 this.form[i].qyCfsj = this.currentTime;
                formData.append("cfsj", this.form[i]);
              } else if (i != "file" && (i != "qyCfwh" || i != "qyCfsj")) {
                formData.append(i, this.form[i]);
              }
            }

            //获取file中的数据
            // for (let i=0; i<this.form.file['1'].length; i++) {
            // 	for(let j=0; j<this.form.file['1'][i].length; j++){
            // 		if (this.form.file['1'][i][j].objfile){
            // 			formData.append("file1", this.form.file['1'][i][j].objfile);
            // 			formData.append("index1", this.form.file['1'][i][j].index);
            // 			console.log("file1",formData.get("file1"),formData.get("index1"))
            // 		}
            // 	}
            // }
            for (let i in this.form.file) {
              for (let j in this.form.file[i]) {
                if (i == 1 || i == 2) {
                  for (let b in this.form.file[i][j]) {
                    if (this.form.file[i][j][b].objfile) {
                      formData.append(
                        "file" + i,
                        this.form.file[i][j][b].objfile
                      );
                      formData.append(
                        "index" + i,
                        this.form.file[i][j][b].index
                      );
                    }
                  }
                } else {
                  if (this.form.file[i][j].objfile) {
                    formData.append("file" + i, this.form.file[i][j].objfile);
                    formData.append("index" + i, this.form.file[i][j].index);
                  }
                }
              }
            }
            //区分申请报告和关联企业
            if(this.lxId){
              // formData.append('lxId',this.lxId);
              formData.append("isApplyFor",0);
            }else{
              formData.append("isApplyFor", this.isApplyFor);
            }

            ajax
              .post(SOWINURL + "index/qyrz", formData)
              .then(function (json) {
                if (json.data.result == 1) {
                  _self.$router.push("/ddsh?tel=" + _self.$store.state.tel);
                } else {
                  _self.$message({
                    showClose: true,
                    message: json.data.errorcode,
                    type: "error",
                  });
                }
                loading.close();
              })
              .catch(function (error) {
                loading.close();
                console.log(error);
              });
          } else {
            //修改提交时

            let ajax = _self.$http.create({
              headers: {
                "Content-Type": "multipart/form-data",
                token: cookie.get("xyxf_token_qt"),
              },
            });
            const loading = this.$loading({
              lock: true,
              text: "Loading",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            });
            let formData = new FormData();
            for (let i in this.form) {

              if (i == "qyFwnr") {
                formData.append("qyFwnr", 2);
              } else if (i == "qyCfwh") {
				  this.form[i].qyCfwh = 'cfwh';
                formData.append("cfwh", this.form[i]);
              } else if (i == "qyCfsj") {
				  this.form[i].qyCfsj = this.currentTime;
                formData.append("cfsj", this.form[i]);
				console.log(this.form[i])
              } else if (i != "file" && (i != "qyCfwh" || i != "qyCfsj")) {
                formData.append(i, this.form[i]);
              }
            }
            for (let i in this.form.file) {
              for (let j in this.form.file[i]) {
                if (i == 1 || i == 2) {
                  for (let b in this.form.file[i][j]) {
                    if (this.form.file[i][j][b].objfile) {
                      formData.append(
                        "file" + i,
                        this.form.file[i][j][b].objfile
                      );
                      formData.append(
                        "index" + i,
                        this.form.file[i][j][b].index
                      );
                    }
                  }
                } else {
                  if (this.form.file[i][j].objfile) {
                    formData.append("file" + i, this.form.file[i][j].objfile);
                    formData.append("index" + i, this.form.file[i][j].index);
                  }
                }
              }
            }

            formData.append("qyId", this.$route.query.qyId);
            //区分申请报告和关联企业
            formData.append("isApplyFor", this.isApplyFor);
            ajax
              .post(SOWINURL + "index/qyrzupdate", formData)
              .then(function (json) {
                if (json.data.result == 1) {
                  _self.$router.push("/ddsh?tel=" + _self.$store.state.tel);
                } else {
                  _self.$message({
                    showClose: true,
                    message: json.data.errorcode,
                    type: "error",
                  });
                }
                loading.close();
              })
              .catch(function (error) {
                loading.close();
                console.log(error);
              });
          }
        } else {
          return false;
        }
      });
    },
    bgClick() {
      let input = document.getElementById("drawerFileInput");
      input.click();
    },
    //点击图片删除
    delFlie(index, item) {
      let _self = this;
      this.$confirm("确认删除该文件？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (item.objfile) {
            if (
              this.activeType == 1 ||
              this.activeType == 2 ||
              this.activeType == 5
            ) {
              //12-5如果是处罚资料删除赋值空
              if (this.activeType == 1 || this.activeType == 2) {
                _self.form.file[this.activeType][this.activeTypeCode].splice(
                  index,
                  1
                );
              } else {
                _self.form.file[this.activeType][this.activeTypeCode] = {};
              }
            } else {
              _self.form.file[this.activeType].splice(index, 1);
            }
            _self.$message("已删除");
          } else {
            _self.delQyfj(index, item);
          }
        })
        .catch(() => {});
    },
    delQyfj(index, item) {
      let _self = this;
      let ajax = _self.$http.create();
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      ajax({
        method: "post",
        url: SOWINURL + "index/delQyfj",
        data: {
          pkFjId: item.fjId,
        },
        headers: {
          token: cookie.get("xyxf_token_qt"),
        },
      })
        .then(function (json) {
          if (json.data.result == 1) {
            if (
              _self.activeType == 1 ||
              _self.activeType == 2 ||
              _self.activeType == 5
            ) {
              //12-5如果是处罚资料删除赋值空
              if (_self.activeType == 1 || _self.activeType == 2) {
                _self.form.file[_self.activeType][_self.activeTypeCode].splice(
                  index,
                  1
                );
              } else {
                _self.form.file[_self.activeType][_self.activeTypeCode] = {};
              }
            } else {
              _self.form.file[_self.activeType].splice(index, 1);
            }

            _self.$message("已删除");
          } else {
            _self.$message({
              showClose: true,
              message: json.data.errorcode,
              type: "error",
            });
          }
          loading.close();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    fileChange(e) {
      // console.log(e);
      let _self = this;
      if (e.target.files[0]) {
        let size = e.target.files[0].size / 1024 / 1024;
        if (size > 2) {
          this.$message.error("图片大小不能超过2M！");
          return false;
        }

        let fileName = e.target.files[0].name.replace(/.+\./, "");
        if (["jpg", "png", "jgeg"].indexOf(fileName.toLowerCase()) === -1) {
          this.$message.error("请上传jpg、png格式的图片！");
          return false;
        }

        let reads = new FileReader();
        reads.readAsDataURL(e.target.files[0]);

        reads.onload = function () {
          let temp = {
            objfile: e.target.files[0],
            url: this.result,
            index: _self.activeTypeCode,
          };
          //限定上传处罚资料一行不能超过一张
          if (
            _self.activeType == "1" ||
            _self.activeType == "2" ||
            _self.activeType == "5"
          ) {
            //上传一张直接关闭
            // _self.drawer = false;
            if (_self.activeType == "1") {
              //当是处罚通知书时用数组去对应
              _self.form.file["1"][_self.activeTypeCode].push(temp);
              _self.form.file[_self.activeType].splice();
              // console.log(_self.form.file['1'],_self.activeTypeCode)
            } else if (_self.activeType == "2") {
              //当是履约证明时用数组去对应
              _self.form.file["2"][_self.activeTypeCode].push(temp);
              _self.form.file[_self.activeType].splice();
              // console.log(_self.form.file['1'],_self.activeTypeCode)
            } else {
              // _self.form.file[_self.activeType].length[_self.activeTypeCode].url
              // console.log(_self.activeType,_self.activeTypeCode)
              if (_self.form.file[_self.activeType][_self.activeTypeCode].url) {
                _self.$message({
                  showClose: true,
                  message: "处罚资料单次只能上传一张",
                  type: "error",
                });
              } else {
                // _self.form.file[_self.activeType].push(temp);
                _self.form.file[_self.activeType][_self.activeTypeCode] = temp;
                _self.form.file[_self.activeType].splice();
              }
            }

            if (_self.activeType == "5") {
              //如果是信用承诺书时识别一下里面数据
              let key = _self.activeType;
              let file = _self.form.file[key];
              let index_1 = _self.activeTypeCode;
              _self.getFjwz(file, index_1, key);
            }
          } else {
            _self.form.file[_self.activeType].push(temp);
            _self.form.file[_self.activeType].splice();
            if (_self.activeType == "4" || _self.activeType == "3") {
              //如果是身份证号时识别一下里面数据
              let key = _self.activeType;
              let file = _self.form.file[key][0];
              console.log(key, file);
              _self.getFjwz(file, "", key);
            }
          }
          // console.log(111)
          e.target.value = "";
        };
      }
    },
    isCellPhone(val) {
      if (!/^1(3|4|5|6|7|8)\d{9}$/.test(val)) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style scoped lang="less" type="text/less">
.index_new {
  background: #fff;
  padding: 30px 100px;
  width: 1010px;
  margin: 20px auto;

  .icon-del {
    color: red;
    font-size: 24px;
    cursor: pointer;
  }
  h3 {
    line-height: 44px;
    height: 44px;
    text-align: center;
    font-size: 24px;
    color: #06103b;
    margin-bottom: 30px;
  }

  .form_span span {
    font-size: 13px;
    color: #949fb5;
    padding-left: 10px;
  }

  .submit {
    width: 130px;
    height: 43px;
    background: #4698FF;
    border-radius: 8px;
	text-align: center;
	line-height: 43px;
	color: #fff;
  cursor: pointer;
  }

  .an {
    background: #e5e5e5;
  }

  .file_ul {
    position: relative;
    display: inline-block;
    width: 100%;
    margin-top: 10px;
    margin-bottom: 30px;
    .file_li {
      display: inline-block;
      margin-right: 50px;
      cursor: pointer;
      .ysc {
        position: absolute;
        left: 0;
        bottom: -30px;
        width: 80px;
        color: #0076ff;
        padding-left: 15px;
      }
      .file_img {
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
        // width: 100px;
        // height: 90px;
        // padding-top: 30px;
        background: #fff;
        text-align: center;
        -moz-box-shadow: 0px 0px 15px #d5d5d5; /* 老的 Firefox */
        box-shadow: 0px 0px 15px #d5d5d5;
        em {
          font-size: 32px;
          color: #0076ff;
        }
        p {
          font-size: 13px;
          color: #0076ff;
          margin-top: 5px;
        }
      }
      .file_img:hover {
        -moz-box-shadow: 0px 0px 25px #d5d5d5; /* 老的 Firefox */
        box-shadow: 0px 0px 25px #d5d5d5;
      }
      p {
        height: 42px;
        line-height: 42px;
        text-align: center;
        font-size: 14px;
        color: #9199aa;
      }
    }
  }
}
.uploadBnt {
  width: 100px;
  height: 120px;
  overflow: hidden;
  float: left;
  margin-bottom: 10px;
  .bg {
    width: 100px;
    height: 120px;
    position: absolute;
    left: 0;
    top: 0;
    background: #d2d2d2;
    font-size: 20px;
    text-align: center;
    line-height: 120px;
    color: #fff;
    cursor: pointer;
    z-index: 1;
  }
}
.drawer_p {
  padding-left: 15px;
  font-size: 14px;
  margin-bottom: 10px;
  color: red;
}
.input_ul {
  margin-left: 15px;
  .input_li {
    width: 100px;
    height: 120px;
    float: left;
    cursor: pointer;
    margin-right: 15px;
    margin-bottom: 10px;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
    .mask {
      position: absolute;
      left: 0;
      top: 0;
      background: rgba(0, 0, 0, 0.3);
      text-align: center;
      width: 100px;
      height: 120px;
      line-height: 120px;
      color: #fff;
      cursor: pointer;
      z-index: 1;
    }
    .mask:hover {
      background: rgba(0, 0, 0, 0.5);
      font-size: 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index/index_new.vue